'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = require('underscore');

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

var _AgentTypes = require('conversations-schema/constants/AgentTypes');

var _PubNubMessageModel = require('conversations-schema/models/PubNubMessageModel');

var _ConversationalMessageModel = require('conversations-schema/models/ConversationalMessageModel');

var _ColoringRecord = require('conversations-schema/records/ColoringRecord');

var _ColoringRecord2 = _interopRequireDefault(_ColoringRecord);

var _ChatMessage = require('ui-addon-conversations/components/ChatMessage');

var _ChatMessage2 = _interopRequireDefault(_ChatMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function MessageGroup(props) {
  var messages = props.messages,
      allMessages = props.allMessages,
      currentRole = props.currentRole,
      coloring = props.coloring,
      readOnly = props.readOnly,
      publishMessage = props.publishMessage,
      republishMessage = props.republishMessage,
      renderMessage = props.renderMessage,
      responders = props.responders;


  var groupSize = messages.size;

  var messageElements = messages.reduce(function (nodes, message, indexInGroup) {
    var timestamp = (0, _PubNubMessageModel.getTimestamp)(message);
    var from = (0, _ConversationalMessageModel.getFrom)(message);
    var senderId = (0, _PubNubMessageModel.getSenderId)(message);
    var senderType = (0, _PubNubMessageModel.getSenderType)(message) || _AgentTypes.HUMAN;

    var messageRole = from;
    var isFirstInGroup = indexInGroup === 0;
    var isLastInGroup = indexInGroup === groupSize - 1;

    var responder = responders ? responders.getIn([senderType, senderId]) : undefined;

    var messageElement = _react2.default.createElement(_ChatMessage2.default, {
      key: timestamp + '-' + from,
      message: message,
      responder: responder,
      allMessages: allMessages,
      currentRole: currentRole,
      messageRole: messageRole,
      coloring: coloring,
      isFirstInGroup: isFirstInGroup,
      isLastInGroup: isLastInGroup,
      publishMessage: publishMessage,
      republishMessage: republishMessage,
      readOnly: readOnly
    });

    var indexInHistory = allMessages.findIndex(function (msg) {
      return msg.equals(message);
    });

    var wrappedMessageElement = renderMessage(messageElement, message, indexInHistory);

    return [].concat(_toConsumableArray(nodes), [wrappedMessageElement]);
  }, []);

  return _react2.default.createElement(
    'span',
    null,
    messageElements
  );
}

MessageGroup.propTypes = {
  messages: _react.PropTypes.instanceOf(_immutable.List).isRequired,
  allMessages: _react.PropTypes.instanceOf(_immutable.List).isRequired,
  responders: _react.PropTypes.instanceOf(_immutable.Map),
  currentRole: _react.PropTypes.oneOf((0, _underscore.values)(_RoleTypes2.default)).isRequired,
  coloring: _react.PropTypes.instanceOf(_ColoringRecord2.default),
  readOnly: _react.PropTypes.bool.isRequired,
  renderMessage: _react.PropTypes.func.isRequired,
  publishMessage: _react.PropTypes.func,
  republishMessage: _react.PropTypes.func
};

exports.default = MessageGroup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.133/js/components/MessageGroup.js
// module id = 401
// module chunks = 0 1